/* -------------------------------------------------------------------------- */
/*                            External Dependencies                           */
/* -------------------------------------------------------------------------- */
import React, { useEffect, useState } from 'react';

/* -------------------------- Internal Dependencies ------------------------- */
import { ScoutBarProps } from 'index';
import { classNames, getOS } from 'utils';
import Icon from 'components/icon';

/* @ts-ignore */
import styles from './snackbar.module.scss';
import useScoutKey from 'use-scout-key';

interface IScoutSnackbarProps extends Partial<ScoutBarProps> {
  setController: Function;
}

const ScoutSnackBar: React.FC<IScoutSnackbarProps> = ({
  setController,
  snackBar,
  theme,
}) => {
  const [showSnackBar, setShowSnackBar] = useState(false);
  const metaKey = useScoutKey('Meta');

  useEffect(() => {
    if (metaKey) {
      setShowSnackBar(true);
    }
  }, [metaKey]);

  return (
    <>
      {showSnackBar && (
        <div
          className={classNames([
            'scout__bar-snack-bar',
            styles.scoutbarSnackBar,
            `scout__bar-wrapper-theme-${theme}`,
            styles[snackBar?.position || 'bottom'],
          ])}
          style={{
            ['--scout-snackbar-background' as string]: snackBar?.background,
            ['--scout-snackbar-color' as string]: snackBar?.color,
            ...snackBar?.style,
          }}
        >
          <button onClick={() => setController(true)} className={styles.button}>
            <p>
              Use{' '}
              <span>
                {getOS() === 'Mac' ? (
                  <Icon width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M9.3 17.85C9.3 18.473 9.11526 19.082 8.76913 19.6C8.423 20.1181 7.93104 20.5218 7.35545 20.7602C6.77987 20.9986 6.14651 21.061 5.53547 20.9395C4.92443 20.8179 4.36315 20.5179 3.92262 20.0774C3.48208 19.6369 3.18207 19.0756 3.06053 18.4645C2.93898 17.8535 3.00136 17.2201 3.23978 16.6445C3.4782 16.069 3.88194 15.577 4.39996 15.2309C4.91797 14.8847 5.52699 14.7 6.15 14.7H17.85C18.473 14.7 19.082 14.8847 19.6 15.2309C20.1181 15.577 20.5218 16.069 20.7602 16.6445C20.9986 17.2201 21.061 17.8535 20.9395 18.4645C20.8179 19.0756 20.5179 19.6369 20.0774 20.0774C19.6369 20.5179 19.0756 20.8179 18.4645 20.9395C17.8535 21.061 17.2201 20.9986 16.6445 20.7602C16.069 20.5218 15.577 20.1181 15.2309 19.6C14.8847 19.082 14.7 18.473 14.7 17.85V6.15C14.7 5.52699 14.8847 4.91797 15.2309 4.39996C15.577 3.88194 16.069 3.4782 16.6445 3.23978C17.2201 3.00136 17.8535 2.93898 18.4645 3.06053C19.0756 3.18207 19.6369 3.48208 20.0774 3.92262C20.5179 4.36315 20.8179 4.92443 20.9395 5.53547C21.061 6.14651 20.9986 6.77987 20.7602 7.35545C20.5218 7.93104 20.1181 8.423 19.6 8.76913C19.082 9.11526 18.473 9.3 17.85 9.3H6.15C5.52699 9.3 4.91797 9.11526 4.39996 8.76913C3.88194 8.423 3.4782 7.93104 3.23978 7.35545C3.00136 6.77987 2.93898 6.14651 3.06053 5.53547C3.18207 4.92443 3.48208 4.36315 3.92262 3.92262C4.36315 3.48208 4.92443 3.18207 5.53547 3.06053C6.14651 2.93898 6.77987 3.00136 7.35545 3.23978C7.93104 3.4782 8.423 3.88194 8.76913 4.39996C9.11526 4.91797 9.3 5.52699 9.3 6.15V17.85Z"
                      stroke="black"
                      strokeWidth="1.5"
                    />
                  </Icon>
                ) : (
                  <Icon width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M4 16.9858V7.01384C3.99994 6.87078 4.05099 6.73241 4.14396 6.62368C4.23692 6.51495 4.36567 6.44301 4.507 6.42084L19.307 4.10784C19.3926 4.0944 19.4802 4.09968 19.5636 4.12331C19.6469 4.14694 19.7242 4.18835 19.7901 4.24471C19.856 4.30106 19.9088 4.37102 19.9451 4.44976C19.9813 4.5285 20 4.61416 20 4.70084V19.2988C20 19.3855 19.9813 19.4712 19.9451 19.5499C19.9088 19.6287 19.856 19.6986 19.7901 19.755C19.7242 19.8113 19.6469 19.8527 19.5636 19.8764C19.4802 19.9 19.3926 19.9053 19.307 19.8918L4.507 17.5788C4.36567 17.5567 4.23692 17.4847 4.14396 17.376C4.05099 17.2673 3.99994 17.1289 4 16.9858V16.9858Z"
                      stroke="black"
                      stroke-width="1.5"
                    />
                    <path d="M4 12H20" stroke="black" stroke-width="1.5" />
                    <path
                      d="M10.5 5.5V18.5"
                      stroke="black"
                      stroke-width="1.5"
                    />
                  </Icon>
                )}
              </span>
              +<span>K</span> to trigger search
            </p>
          </button>
          <button
            onClick={() => setShowSnackBar(false)}
            className={styles.CloseIcon}
          >
            <Icon width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M6.22517 4.81099C6.03657 4.62883 5.78397 4.52803 5.52177 4.53031C5.25957 4.53259 5.00876 4.63776 4.82335 4.82317C4.63794 5.00858 4.53278 5.25939 4.5305 5.52158C4.52822 5.78378 4.62901 6.03638 4.81117 6.22499L10.5862 12L4.81017 17.775C4.71466 17.8672 4.63848 17.9776 4.58607 18.0996C4.53366 18.2216 4.50607 18.3528 4.50492 18.4856C4.50377 18.6184 4.52907 18.75 4.57935 18.8729C4.62963 18.9958 4.70388 19.1075 4.79778 19.2014C4.89167 19.2953 5.00332 19.3695 5.12622 19.4198C5.24911 19.4701 5.38079 19.4954 5.51357 19.4942C5.64635 19.4931 5.77757 19.4655 5.89958 19.4131C6.02158 19.3607 6.13192 19.2845 6.22417 19.189L12.0002 13.414L17.7752 19.189C17.9638 19.3711 18.2164 19.4719 18.4786 19.4697C18.7408 19.4674 18.9916 19.3622 19.177 19.1768C19.3624 18.9914 19.4676 18.7406 19.4698 18.4784C19.4721 18.2162 19.3713 17.9636 19.1892 17.775L13.4142 12L19.1892 6.22499C19.3713 6.03638 19.4721 5.78378 19.4698 5.52158C19.4676 5.25939 19.3624 5.00858 19.177 4.82317C18.9916 4.63776 18.7408 4.53259 18.4786 4.53031C18.2164 4.52803 17.9638 4.62883 17.7752 4.81099L12.0002 10.586L6.22517 4.80999V4.81099Z"
                fill="black"
              />
            </Icon>
          </button>
        </div>
      )}
    </>
  );
};

export default ScoutSnackBar;
